import { UserNotificationConstants } from 'finhelper';
import { Api } from 'laravel-request';

export const handleLogClick = async (item, clientId, setActiveNotification) => {
  if (!clientId || !item?.id) return;

  let query = Api.get('user-notification', 'index', { user_id: clientId }).where('id', item.id);

  switch (item.action_id) {
    case UserNotificationConstants.TRANSFERED_STOCK:
      query.with('items', (q) =>
        q.where('is_confirmed', 0).orderBy('id').with('post', 'post.active', 'local_operation')
      );
      break;

    case UserNotificationConstants.NOT_FOUND_STOCK:
      query.with('items', (q) =>
        q
          .where('is_confirmed', 0)
          .orderBy('id')
          .with(
            'post',
            'local_operation',
            'local_operation.transfer_stocks',
            'local_operation.transfer_stocks.aton_relation'
          )
      );
      break;

    case UserNotificationConstants.NEGATIVE_TRADES:
      query.with('items', (q) =>
        q
          .where('is_confirmed', 0)
          .orderBy('id')
          .with('post', 'post.active', 'post.active.item', 'local_operation')
      );
      break;

    case UserNotificationConstants.NOT_FOUND_MONEY_ON_DATE:
    case UserNotificationConstants.ERROR_COUNT_STOCK:
      query.with('items', (q) => q.where('is_confirmed', 0).orderBy('id').with('post'));
      break;

    case UserNotificationConstants.TRANSFERED_TO_ZERO:
      query.with('items', (q) =>
        q
          .where('is_confirmed', 0)
          .orderBy('id')
          .with('post', 'post.childs', 'post.active', 'local_operation')
      );
      break;
  }

  query.first((response) => {
    const data = response?.data ?? response;
    if (!data) return;

    setActiveNotification({
      type: item.action_id,
      id: item.id,
      item: data,
    });
  });
};
